import { call } from 'redux-saga/effects'
import { message } from 'antd'
import _store from './store'
import { LOADING } from './actionTypes'
import { getNamespace } from '../utils/util'

type Options = {
  loadingName?: string
  loading?: boolean
}

type Fn = (...args: any[]) => Promise<ResponseData>

const flag: { [name: string]: any } = {}

export default function* callWithLoadingStatus(
  fn: Fn,
  effect: Payload,
  options = {}
): Generator<any, Promise<ResponseData>, any> {
  const { loading = true, loadingName } = options as Options
  const loadingPayload = loadingName ? { type: loadingName } : effect
  const name = getNamespace(loadingPayload?.type) as string
  if (loading) {
    if (!flag[name]) {
      flag[name] = 1
    } else {
      flag[name]++
    }
    yield _store.dispatch({
      type: LOADING.SHOWLOADING,
      payload: loadingName ? { type: loadingName } : effect,
    })
  }
  let response = null
  try {
    response = yield call(fn, effect.payload)
  } catch (error: any) {
    message.error(error?.message)
  } finally {
    if (loading) {
      flag[name]--
      if (flag[name] === 0) {
        yield _store.dispatch({
          type: LOADING.HIDELOADING,
          payload: loadingName ? { type: loadingName } : effect,
        })
      }
    }
  }

  return response
}
